import React from "react";

function Image({src, description}:{src:any, description:any}) {
    return <img className="imgjauge" src={src} alt={description}/>;
}

export default Image;
